<template>
  <v-card outlined>
    <v-data-table
      :items="list"
      :headers="headers"
      :loading="loading"
      disable-pagination
      hide-default-footer
      :sort-by="['lastActiveDate']"
      :sort-desc="[true]"
      class="row-pointer"
      mobile-breakpoint="0"
      @click:row="rowClick"
    >
      <template #[`item.published`]="{ item }">
        <v-icon
          small
          :color="item.published ? 'success' : 'error'"
        >
          wifi
        </v-icon>
      </template>
      <template #[`item.createdDate`]="{ item }">
        {{ item.createdDate | normalDate }}
      </template>
      <template #[`item.lastActiveDate`]="{ item }">
        {{ item.lastActiveDate | normalDateWithTime }}
      </template>
      <template #[`item.unpaid`]="{ item }">
        <template v-if="item.unpaid">
          {{ item.unpaid | currency }}
        </template>
        <v-icon v-else> remove </v-icon>
      </template>
      <template #[`item.status`]="{ item }">
        <UserPayButton
          :sub-total="item.unpaid"
          :user-id="item.id"
        />
      </template>
      <template #[`item.actions`]="{}">
        <v-icon>more_vert</v-icon>
      </template>
    </v-data-table>
    <UserPayDrawer />
  </v-card>
</template>

<script>
import UserPayButton from '@/components/users/pay/Button';
import UserPayDrawer from '@/components/users/pay/Drawer';
import { mapGetters } from 'vuex';
export default {
  name: 'ContributorsList',
  components: { UserPayButton, UserPayDrawer },
  data: () => {
    return {
      headers: [
        { text: 'Name', value: 'fullName' },
        { text: 'Created', value: 'createdDate' },
        { text: 'Last active', value: 'lastActiveDate' },
        { text: 'Customer', value: 'unpaidCustomerProjectCount' },
        { text: 'Unpaid', value: 'unpaid' },
        { text: 'Status', value: 'status' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      list: 'users/list'
    })
  },
  mounted() {
    this.$store.dispatch('users/reset');
    this.loading = true;
    this.$store
      .dispatch('users/getContributors')
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    rowClick(item) {
      this.$router.push({ path: `/users/${item.id}` });
    }
  }
};
</script>
